function shouldShowDemoLogin(env = process.env) {
  return env.NODE_ENV !== 'production' || env.REACT_APP_ENABLE_DEMO_LOGIN === 'true';
}

function shouldShowLocalSocialLoginStubs(env = process.env) {
  return env.NODE_ENV !== 'production'
    && env.REACT_APP_SHOW_LOCAL_SOCIAL_LOGIN_STUBS === 'true';
}

module.exports = {
  shouldShowDemoLogin,
  shouldShowLocalSocialLoginStubs,
};
